import React, { useEffect, useState } from "react";
import IntransitDataComponent from "./IntransitDataComponent";
import MyLoader from "../HOC/MyLoader";
const ShippingComponent = (props) => {
  console.log("ShippingComponent", props);

  // useEffect(() => {
  //   // Update the document title using the browser API
  //   api.callAssignedJobs(this, "in-transit");
  // }, []);

  return (
    <div>
      <IntransitDataComponent trips={props.jobs} />
    </div>
  );
};
export default MyLoader(ShippingComponent, "intransit");



// WEBPACK FOOTER //
// ./src/components/Intransit/IntransitComponent.js